const UtilitariosApi = (API) => {
  const baseUrlAtendente = process.env.VUE_APP_OMNI_API_UTILITARIOS_AT
  const baseUrlAnonimo = process.env.VUE_APP_OMNI_API_UTILITARIOS_AN
  return {
    async getUrlAssinada ({ bucket, fileKey, expireInSec, forceDownload, options = {} }) {
      const url = `${baseUrlAnonimo}/upload/preSigning`
      const request = API.post(
        url,
        {
          bucket,
          tempoExpiracaoS: expireInSec,
          forcaDownload: forceDownload,
          data: [{ key: fileKey }]
        })
      return API.notifyRequest(request, options)
    },
    async checkFileBucket ({ bucket, key, options = {} }) {
      const url = `${baseUrlAnonimo}/upload/checkFileBucket`
      const request = API.post(url, { bucket, key })
      return API.notifyRequest(request, options)
    },
    async iniciarAtendimentoMemed ({
      authorization,
      chaveUnica,
      bundle,
      instanciaAplicacao,
      aceitaTermos = false
    }) {
      const data = {
        aceitaTermos
      }

      if (chaveUnica) {
        data.chaveUnica = chaveUnica
      }

      return API.post(`${baseUrlAtendente}/memed/iniciarAtendimento`, data, {
        headers: {
          authorization,
          bundle,
          instancia_aplicacao: instanciaAplicacao
        }
      })
    }
  }
}
export default UtilitariosApi
